import React, { useContext } from 'react';
import UiSaveButtons from '../../../global/components/buttons/UiSaveButtons';
import FullPageWrapper from '../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import Golfers, { golfersModes } from './Golfers';

const GolferChange = (props) => {

  const { golfer, handleCancel } = props
  const { firstName, lastName } = golfer ?? {}

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, handlers } = golfParent_contexts ?? {}
  const { golfEvent_state, golfTournament_state } = states ?? {}
  const { golfTournament_handlers } = handlers ?? {}

  const { golfers: golfers_event } = golfEvent_state ?? {}
  const { updating, checkedGolfer } = golfTournament_state ?? {}

  /** Saves the handicap to the database (event or tournament) */
  const handleChangeGolfer = () => {
    const newGolfer = golfers_event[checkedGolfer]
    golfTournament_handlers.handleStartUpdate()
    golfTournament_handlers.handleChange_golferTournament(golfer._itemKey, newGolfer)
    handleCancel()
  }

  const handicapFooter = () => <UiSaveButtons
    save={{ oc: handleChangeGolfer, caption: 'Update Golfer', disabled: !checkedGolfer }}
  />

  const handicapWrapper = () => <Wrapper
    content={<Golfers golfersMode={golfersModes.tournamentChange} />}
    footer={handicapFooter()}
    wrapperType={wrapperTypes.paddedFooter}
  />

  const handicapContent = () => <FullPageWrapper
    content={handicapWrapper()}
    handleCancel={handleCancel}
    updating={updating}
    topperCaption={'Change Golfer'}
    topperCaption2={firstName + ' ' + lastName}
  />

  return handicapContent()
}

export default GolferChange